<template>
  <div class="suspend" v-if="show">
    <img class="share" @click="share" src="https://s.kcimg.cn/topic/images/new-retail/share.png" alt />
    <div>
      <a href="tel:4008806283"  @click="sendAnalytics('配件新零售招商专题活动', '点击客服', '')" class="tel" target="_top" v-if="!isNewApp"></a>
      <span v-else class="tel" @click="appTel('4008806283')"></span>
    </div>
    <!-- <a
      class="tel"
      src="https://s.kcimg.cn/topic/images/new-retail/tel.png"
      alt
      @click="appTel"
    ></a>-->
  </div>
</template>
<script>
// import XHR from '../api'
export default {
  name: 'Suspend',
  props: [],
  data: () => ({
    tel: '',
    suspendObj: {},
    show: false,
    timer: '',
    isNewApp: false
  }),
  components: {
  },
  created () {
    // // 获取客服电话号码
    // XHR.getHandWork({
    //   type: 17,
    //   hid: 3862
    // }).then(res => {
    //   const { status, data } = res.data
    //   if (!status) {
    //     this.tel = data[0].title
    //   }
    // })
    // // 获取下方按钮
    // XHR.getHandWork({
    //   type: 2,
    //   hid: 3845
    // }).then(res => {
    //   const { status, data } = res.data
    //   if (!status) {
    //     this.suspendObj = data[0]
    //   }
    // })
  },
  mounted () {
    if (window.CHESPEED && window.CHEIOS) {
      this.isNewApp = true
    }
    window.onscroll = (e) => {
      const top = document.documentElement.scrollTop || document.body.scrollTop
      const screenTop = document.body.clientHeight
      if (top > screenTop) {
        this.show = true
      } else {
        this.show = false
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    appTel (telNum) {
      this.sendAnalytics('配件新零售招商专题活动', '点击客服', '')
      window.callNativeMethod('onDial', {
        tel: telNum
      })
    },
    // 回到顶部
    scrollTop () {
      // 清空上一次的定时器
      clearInterval(this.timer)
      const toTop = document.querySelector('.big-gift').offsetHeight
      this.timer = setInterval(() => {
        const top = document.documentElement.scrollTop || document.body.scrollTop
        const speed = Math.ceil((top - toTop) / 5)
        document.body.scrollTop = document.documentElement.scrollTop = top - speed
        if (top <= toTop) {
          clearInterval(this.timer)
        }
      }, 20)
    },
    // 点击分享
    share () {
      this.sendAnalytics('配件新零售招商专题活动', '点击分享', '')
      this.$emit('click', this.deviceType)
    }
  }
}
</script>
<style lang="less" scoped>
.suspend {
  z-index: 1000;
  position: fixed;
  display: flex;
  flex-direction: column;
  right: 12px;
  bottom: 20px;
  .share {
    width: 48px;
    height: 48px;
    margin-bottom: 12px;
  }
  .tel {
    display: inline-block;
    width: 48px;
    height: 48px;
     &::after{
       content: '';
      background: url('https://s.kcimg.cn/topic/images/new-retail/tel.png') no-repeat 50% 50%;
      background-size: contain;
      display: inline-block;
      width: 48px;
      height: 48px;
    }
  }
}
</style>
